import React, { useEffect, useRef } from 'react'

const TriStateCheckbox = ({
  state = 'none',
  onChange,
  className = '',
  disabled = false
}) => {
  const inputRef = useRef(null)

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.indeterminate = state === 'some'
    }
  }, [state])

  return (
    <input
      ref={inputRef}
      type="checkbox"
      className={`h-[18px] w-[18px] cursor-pointer accent-primary ${className}`}
      checked={state === 'all'}
      disabled={disabled}
      onClick={event => event.stopPropagation()}
      onChange={onChange}
    />
  )
}

export default TriStateCheckbox
